exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".help-boxes{margin-top:30px;font-size:2rem;font-weight:500;text-align:center}.help-boxes .help-box{background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/helpboxes/helpboxes.styl
// module id = 498
// module chunks = 0